const pagesDealLedgerEn = {
  addButtonCancel: 'Cancel',
  addButtonNew: 'New Deal',
  addButtonRegister: 'Register',
  addErrorRequired: 'This field is required',
  addPageTitle: 'New Deal',
  addSuccessMessage: 'Deal created successfully.',
  completedByLabel: 'Registered by',
  completedGoToDetail: 'View Details',
  completedMessage: 'Deal registered successfully!',
  completedRegisterAnother: 'Register Another',
  completedTitle: 'Registration Complete',
  dealDirection: {
    INBOUND: 'Inbound (Purchase)',
    OUTBOUND: 'Outbound (Sales)',
  },
  dealNodeStatus: {
    COMPLETED: 'Completed',
    IN_PROGRESS: 'In Progress',
    NOT_STARTED: 'Not Started',
  },
  dealProgressNoVisibleNodes:
    'There are no progress nodes to display. Enable a stage in the flow configuration above to start tracking progress.',
  dealProgressNodeAdvancesPayment: 'Advances Payment',
  dealProgressNodeAdvancesReceived: 'Advances Received',
  dealProgressNodeCollection: 'Collection',
  dealProgressNodeContract: 'Contract',
  dealProgressNodeInvoice: 'Invoice',
  dealProgressNodeLead: 'Lead',
  dealProgressNodePayment: 'Payment',
  dealProgressNodePaymentRun: 'Payment Run',
  dealProgressNodePurchaseOrder: 'Purchase Order',
  dealProgressNodePurchaseRequest: 'Purchase Request',
  dealProgressNodeQuote: 'Quote',
  dealProgressNodeReceipt: 'Receipt',
  dealProgressNodeRfq: 'RFQ',
  dealProgressNodeSalesOrder: 'Sales Order',
  dealProgressNodeSupplierQuote: 'Supplier Quote',
  dealProgressNodeVendorInvoice: 'Vendor Invoice',
  dealProgressSectionTitle: 'Deal Progress',
  dealSourceRelType: {
    RENEWAL: 'Renewal',
    RETURN: 'Return / Cancellation',
    UPSELL: 'Upsell',
  },
  dealStructureType: {
    BACK_TO_BACK: 'Back-to-Back',
    PARENT_CHILD: 'Parent-Child',
    SOURCE_DEAL: 'Source Deal',
  },
  dealType: {
    DOWNSELL: 'Downsell',
    NEW: 'New',
    RENEWAL: 'Renewal',
    UPSELL: 'Upsell',
  },
  detailFieldBusinessPartnerId: 'Business Partner',
  detailFieldCreatedAt: 'Created At',
  detailFieldDealNumber: 'Deal Number',
  detailFieldDealType: 'Deal Type',
  detailFieldDirection: 'Direction',
  detailFieldPipelineStage: 'Pipeline Stage',
  detailFieldResponsiblePersonId: 'Responsible Person',
  detailFieldSummary: 'Summary',
  detailFieldTitle: 'Title',
  detailTabsDetail: 'Details',
  detailTabsFlow: 'Flow Management',
  detailTabsStructure: 'Deal Structure',
  flowMoveDown: 'Move {{stage}} down',
  flowMoveUp: 'Move {{stage}} up',
  flowStageS01: 'Lead / Opportunity',
  flowStageS02: 'Quotation',
  flowStageS03: 'Sales Order',
  flowStageS04: 'Contract',
  flowStageS05: 'Delivery / Shipment',
  flowStageS06: 'Invoice',
  flowStageS07: 'Collection / Receipt',
  flowStageS98: 'On Hold',
  flowStageS99: 'Closed / Completed',
  flowStageSectionTitle: 'Stage Configuration',
  flowTabButtonCancel: 'Cancel',
  flowTabButtonEdit: 'Edit',
  flowTabButtonSave: 'Save',
  flowTabNoConfig: 'No flow configuration available.',
  flowTabTitle: 'Stage Configuration',
  gateButtonNext: 'Next',
  gateCardINBOUNDDesc: 'Procurement and purchasing from suppliers',
  gateCardOUTBOUNDDesc: 'Sales and service delivery to customers',
  gateCardRequiredDetails: 'Required fields',
  gatePageTitle: 'Add a Deal',
  gateSelectDirection: 'Select deal direction',
  listFilterPlaceholder: 'Search by deal name or number...',
  listPageTitle: 'Deal List',
  progressFilled: 'Filled',
  progressRequired: 'Required Items',
  progressTotal: 'Total',
  structureFieldDealSelectPlaceholder: 'Search deal...',
  structureFieldHierarchyLevel: 'Hierarchy Level',
  structureFieldLinkedDealId: 'Linked Deal ID',
  structureFieldParentDealId: 'Parent Deal ID',
  structureFieldRootDealId: 'Root Deal ID',
  structureFieldSourceDealId: 'Source Deal ID',
  structureFieldSourceRelType: 'Source Relation Type',
  structureFieldStructureTypes: 'Structure Types',
  structureSectionBackToBack: 'Back-to-Back',
  structureSectionParentChild: 'Parent-Child',
  structureSectionSourceDeal: 'Source Deal',
  structureTabTitle: 'Deal Structure',
};

export default pagesDealLedgerEn;
